module.exports = __webpack_public_path__ + "static/media/pstep2img1.c0fc96f4.PNG";